<section class="snapicon-carousel-wrapper" #carousel [style.width]="size + 'px'" [style.height]="size + 'px'">
  <div *ngFor="let item of items;" class="snapicon-carousel-item">
    <ng-container [ngTemplateOutlet]="item.tpl"></ng-container>
  </div>
</section>